import React from 'react'
import Redirect from 'components/Redirect'
import { useIsLoggedIn, useKeepMeLoggedIn, useHasAccess } from 'hooks/authHooks'

const PublicOnlyRoute = ({ disableRedirect, children }) => {
  const isLoggedIn = useIsLoggedIn()
  const keepMeLoggedIn = useKeepMeLoggedIn()
  const hasAccess = useHasAccess({ keepMeLoggedIn, isLoggedIn })

  return (
    hasAccess
      ? !disableRedirect && <Redirect to={'/account'} />
      : <>{children}</>
  )
}

export default PublicOnlyRoute
